import styled from 'styled-components'

export const AlertedItemsWrapper = styled.div`
  display: flex;
  gap: 12px;
`
